module.exports = __webpack_public_path__ + "img/2.bb2c7c86.png";